// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  font-family: 'Prompt', Helvetica;
  font-size: 1rem;
  border-color: #6785d3;
  color: #fff;
  box-shadow:
    0 0 10px 0 #6785d3 inset,
    0 0 10px 4px #6785d3;
  transition: all 150ms ease-in-out;
  cursor: pointer;
  background-color: transparent;
  padding: 0.6em 2em;
  border-radius: 1.5em;
  margin-top: 10px;
}

.button:hover {
  box-shadow:
    0 0 40px 40px #6785d3 inset,
    0 0 0 0 #6785d3;
  outline: 0;
}

.button[disabled] {
  background-color: #999999;
  cursor: not-allowed;
  box-shadow: none;
}

/* Icon Buttons */
.icon-instance-node-small {
  color: white;
  width: 1.3em;
  height: 1.3em;
  transition:
    transform 0.3s ease-in-out,
    filter 0.3s ease-in-out;
}

.icon-button {
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  padding: 8px;
  /* height: 40px;
  width: 40px; */
  cursor: pointer;
  transition:
    transform 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.icon-button-no-margin {
  margin: 0 !important;
}

.default {
  background-color: #bccffe1a;
}

.red {
  background-color: #ff4242;
}

.blue {
  background-color: #0149ff;
}

.green {
  background-color: #28c235;
}

/* .icon-red:hover {
  background-color: #ff4242;
  transform: scale(1.1);
} */

.icon-red {
  background-color: #ff4242;
  transform: scale(1.1);
}

/* .icon-blue:hover {
  background-color: #0149ff;
  transform: scale(1.1);
} */
.icon-blue {
  background-color: #0149ff;
  transform: scale(1.1);
}

/* .icon-green:hover {
  background-color: #28c235;
  transform: scale(1.1);
} */

.icon-green {
  background-color: #28c235;
  transform: scale(1.1);
}

.icon-button:hover .icon-instance-node-small {
  filter: brightness(2);
}

.icon-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/styles.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX;;wBAEsB;EACtB,iCAAiC;EACjC,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;;mBAEiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb;;2BAEyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ;gBACc;EACd,eAAe;EACf;;qCAEmC;AACrC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;GAGG;AACH;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".button {\n  font-family: 'Prompt', Helvetica;\n  font-size: 1rem;\n  border-color: #6785d3;\n  color: #fff;\n  box-shadow:\n    0 0 10px 0 #6785d3 inset,\n    0 0 10px 4px #6785d3;\n  transition: all 150ms ease-in-out;\n  cursor: pointer;\n  background-color: transparent;\n  padding: 0.6em 2em;\n  border-radius: 1.5em;\n  margin-top: 10px;\n}\n\n.button:hover {\n  box-shadow:\n    0 0 40px 40px #6785d3 inset,\n    0 0 0 0 #6785d3;\n  outline: 0;\n}\n\n.button[disabled] {\n  background-color: #999999;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Icon Buttons */\n.icon-instance-node-small {\n  color: white;\n  width: 1.3em;\n  height: 1.3em;\n  transition:\n    transform 0.3s ease-in-out,\n    filter 0.3s ease-in-out;\n}\n\n.icon-button {\n  margin-right: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  padding: 8px;\n  /* height: 40px;\n  width: 40px; */\n  cursor: pointer;\n  transition:\n    transform 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n}\n\n.icon-button-no-margin {\n  margin: 0 !important;\n}\n\n.default {\n  background-color: #bccffe1a;\n}\n\n.red {\n  background-color: #ff4242;\n}\n\n.blue {\n  background-color: #0149ff;\n}\n\n.green {\n  background-color: #28c235;\n}\n\n/* .icon-red:hover {\n  background-color: #ff4242;\n  transform: scale(1.1);\n} */\n\n.icon-red {\n  background-color: #ff4242;\n  transform: scale(1.1);\n}\n\n/* .icon-blue:hover {\n  background-color: #0149ff;\n  transform: scale(1.1);\n} */\n.icon-blue {\n  background-color: #0149ff;\n  transform: scale(1.1);\n}\n\n/* .icon-green:hover {\n  background-color: #28c235;\n  transform: scale(1.1);\n} */\n\n.icon-green {\n  background-color: #28c235;\n  transform: scale(1.1);\n}\n\n.icon-button:hover .icon-instance-node-small {\n  filter: brightness(2);\n}\n\n.icon-button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
